import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { useBlogPosts } from './blog/blogData';
import './Blog.css';

const Blog = () => {
  const [selectedTag, setSelectedTag] = useState('all');
  const navigate = useNavigate();
  const { posts, loading } = useBlogPosts();

  // Get all unique tags
  const allTags = ['all', ...new Set(posts.flatMap(post => post.tags))];

  // Filter posts by selected tag
  const filteredPosts = selectedTag === 'all' 
    ? posts 
    : posts.filter(post => post.tags.includes(selectedTag));

  // Navigate to random article
  const goToRandomArticle = () => {
    if (posts.length > 0) {
      const randomPost = posts[Math.floor(Math.random() * posts.length)];
      navigate(`/blog/${randomPost.slug}`);
    }
  };

  if (loading) {
    return (
      <div className="blog-container">
        <div className="blog-header">
          <h1>Blog</h1>
          <p>Loading posts...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-container">
      <div className="blog-header">
        <h1>Blog</h1>
        
        <div className="blog-controls">
          <div className="tag-filters">
            {allTags.map(tag => (
              <button
                key={tag}
                className={`tag-filter ${selectedTag === tag ? 'active' : ''}`}
                onClick={() => setSelectedTag(tag)}
              >
                {tag.charAt(0).toUpperCase() + tag.slice(1)}
              </button>
            ))}
          </div>
          
          <button className="random-btn" onClick={goToRandomArticle}>
            Random Article
          </button>
        </div>
      </div>

      {posts.length === 0 ? (
        <div className="blog-grid">
          <div className="coming-soon">
            <h2>Coming Soon</h2>
            <p>Blog posts are coming soon. Check back later!</p>
          </div>
        </div>
      ) : (
        <>
          <div className="blog-grid">
            {filteredPosts.map(post => (
              <Link to={`/blog/${post.slug}`} key={post.slug} className="blog-card">
                <div 
                  className="blog-card-thumbnail"
                  style={{
                    background: post.thumbnail 
                      ? `url(${post.thumbnail}) center/cover` 
                      : post.gradient
                  }}
                >
                  {!post.thumbnail && (
                    <div className="gradient-overlay">
                      <h3>{post.title}</h3>
                    </div>
                  )}
                </div>
                
                <div className="blog-card-content">
                  <h2>{post.title}</h2>
                  <p className="blog-date">{post.date ? new Date(post.date + 'T12:00:00').toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }) : ''}</p>
                  
                  <div className="blog-tags">
                    {post.tags.map(tag => (
                      <span key={tag} className="blog-tag">{tag}</span>
                    ))}
                  </div>
                  
                  <p className="blog-excerpt">{post.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>

          {filteredPosts.length === 0 && (
            <p className="no-posts">No posts found with this tag.</p>
          )}
        </>
      )}
    </div>
  );
};

export default Blog;